import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { ToggleSwitch } from "@whoosh/design-system/src/components/controls";
import {
  Text,
  VStack,
  HStack,
} from "@whoosh/design-system/src/components/primitive";

import { TeeSheetMultipleBookingToggleFragment_Facility$key } from "./__generated__/TeeSheetMultipleBookingToggleFragment_Facility.graphql";

type TeeSheetMultipleBookingToggleProps = {
  isBookingMultipleTeeTimes: boolean;
  onChange: (val: boolean) => void;
  facilityRef: TeeSheetMultipleBookingToggleFragment_Facility$key | null;
};

export const TeeSheetMultipleBookingToggle = ({
  isBookingMultipleTeeTimes,
  onChange,
  facilityRef,
}: TeeSheetMultipleBookingToggleProps) => {
  const currentFacility = useFragment(
    TeeSheetMultipleBookingToggleFragmentString,
    facilityRef
  );

  const shouldShowMultipleTeeTimeToggle =
    currentFacility?.multipleBookingsEnabled;

  return shouldShowMultipleTeeTimeToggle ? (
    <VStack testID="tee-sheet-multiple-booking-toggle">
      <Text py={2} mb={4} variant="mainSmallSemiBold">
        {t`Book Multiple Times`}
      </Text>

      <HStack alignItems="center" gap={2}>
        <ToggleSwitch
          name="Book Multiple"
          isChecked={isBookingMultipleTeeTimes}
          onToggle={onChange}
          accessibilityLabel={t`book-multiple-toggle`}
        />
        <Text
          variant="mainBaseMedium"
          testID="tee-sheet-multiple-booking-toggle-text"
        >
          {isBookingMultipleTeeTimes ? t`Yes` : t`No`}
        </Text>
      </HStack>
    </VStack>
  ) : null;
};

const TeeSheetMultipleBookingToggleFragmentString = graphql`
  fragment TeeSheetMultipleBookingToggleFragment_Facility on Facility {
    multipleBookingsEnabled
  }
`;
